import React from 'react';
import { Link } from 'react-router-dom';
import logoWhite from '../images/Neoshift Logo White.png';
import './Footer.css';

const Footer = ({ selectedProduct }) => {
  const isBi = selectedProduct === 'bi';

  const privacyLink = isBi
    ? { href: 'https://bi.neoshift.ai/#/privacy', external: true }
    : { to: '/privacy', external: false };

  const termsLink = isBi
    ? { href: 'https://bi.neoshift.ai/#/terms', external: true }
    : { to: '/terms', external: false };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src={logoWhite} alt="Neoshift" className="footer-logo-image" />
              <p>
                AI-native operations for distributors and wholesalers. Neoshift Core connects your
                back office — plus ETL automation and BI analytics when you need them.
              </p>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Products</h4>
            <ul className="footer-links">
              <li>
                <a href="https://core.neoshift.ai" target="_blank" rel="noopener noreferrer">
                  Neoshift Core
                </a>
              </li>
              <li><a href="#features">Neoshift ETL</a></li>
              <li>
                <a href="https://bi.neoshift.ai" target="_blank" rel="noopener noreferrer">
                  Neoshift BI
                </a>
              </li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul className="footer-links">
              <li>
                {privacyLink.external ? (
                  <a href={privacyLink.href} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
                ) : (
                  <Link to={privacyLink.to}>Privacy Policy</Link>
                )}
              </li>
              <li>
                {termsLink.external ? (
                  <a href={termsLink.href} target="_blank" rel="noopener noreferrer">Terms of Service</a>
                ) : (
                  <Link to={termsLink.to}>Terms of Service</Link>
                )}
              </li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-bottom-content">
            <p>&copy; {new Date().getFullYear()} NeoShift. All rights reserved.</p>
            <div className="footer-bottom-links">
              {privacyLink.external ? (
                <a href={privacyLink.href} target="_blank" rel="noopener noreferrer">Privacy</a>
              ) : (
                <Link to={privacyLink.to}>Privacy</Link>
              )}
              {termsLink.external ? (
                <a href={termsLink.href} target="_blank" rel="noopener noreferrer">Terms</a>
              ) : (
                <Link to={termsLink.to}>Terms</Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
